import { render } from "./HotDealsCard.vue?vue&type=template&id=b42de622&scoped=true"
import script from "./HotDealsCard.vue?vue&type=script&lang=js"
export * from "./HotDealsCard.vue?vue&type=script&lang=js"

import "./HotDealsCard.vue?vue&type=style&index=0&id=b42de622&lang=scss&scoped=true"
import "./HotDealsCard.vue?vue&type=style&index=1&id=b42de622&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42de622"]])

export default __exports__